/* --------------------------------------------------------------------------------------
   common.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import { classesComponent, classesCtrl } from './components/classes.component'
import { testsComponent, testsCtrl} from './components/tests.component'
import { testResultsComponent, testResultsCtrl } from './components/testResults.component'
import { errorMessageComponent } from './components/errorMessage.component'
import { commonService } from './services/common.service'
import { dataService } from './services/data.service'
import { printService } from './services/print.service'
import { jobStatusService } from './services/jobStatus.service'
import { deviceInfoService } from './services/deviceInfo.service'
import { persistService } from './services/persist.service'
import { userService } from './services/user.service'
import { logService } from './services/log.service'

export const appCommonModule = angular.module('app.common',[])
  .component('classes', classesComponent)
  .controller('classesCtrl', classesCtrl)
  .component('tests', testsComponent)
  .controller('testsCtrl', testsCtrl)
  .component('testResults', testResultsComponent)
  .controller('testResultsCtrl', testResultsCtrl)
  .component('errorMessage', errorMessageComponent)
  .service('commonService', commonService)
  .service('dataService', dataService)
  .service('printService', printService)
  .service('jobStatusService', jobStatusService)
  .service('deviceInfoService', deviceInfoService)
  .service('persistService', persistService)
  .service('userService', userService)
  .service('logService', logService)



// WEBPACK FOOTER //
// ./src/app/common/common.js